import { useCallback, useMemo } from 'react';

export const useFormatValue = () => {
  const formatter = useCallback((value?: number | string): string => {
    if (!value || Number.isNaN(Number(value))) {
      return '';
    }

    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(Number(value));
  }, []);

  const parser = useCallback((value: string | undefined): number => Number(value?.split(',').join('') ?? 0), []);

  return useMemo(() => ({ formatter, parser }), [formatter, parser]);
};
